import React, { ErrorInfo } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import RequestConfigurationFactoryInstance from './Services/Request/RequestConfigurationFactory';

enum KnownErrors {
  ChunkLoadError = 'ChunkLoadError',
}

type Props = unknown;

interface State {
  error?: Error | null;
}

// @warning Error boundaries must be implement as class components
//          (functional component not supported)
// @see https://reactjs.org/docs/error-boundaries.html
//      https://stackoverflow.com/questions/44601121/code-splitting-causes-chunks-to-fail-to-load-after-new-deployment-for-spa
class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error boundary caught:', error, errorInfo);
    RequestConfigurationFactoryInstance.handleSnagUiError(error);
  }

  render() {
    const { error } = this.state;

    if (!error) {
      return this.props.children;
    }

    if (error.name === KnownErrors.ChunkLoadError) {
      window.location.reload();
      return <></>;
    }

    return (
      <Container maxWidth="xs">
        <Box pt={10} px={0} textAlign="center">
          <Box pt={1} pb={3}>
            <Typography variant="body1">
              An error has occurred. Please refresh and try again.
            </Typography>
          </Box>
          <Button
            color="secondary"
            onClick={() => window.location.reload()}
            variant="outlined"
          >
            Reload
          </Button>
        </Box>
      </Container>
    );
  }
}

export default AppErrorBoundary;
